export default __webpack_public_path__ + "static/media/game_logo.a9bb1445.png";